export default __webpack_public_path__ + "static/media/lemon.e3b7976e.ogg";